const state = {
  hasDuplicates: false,
  duplicatedFields: [],
  canEdit: true
}

const getters = {
  hasDuplicates: (state) => state.hasDuplicates,
  duplicatedFields: (state) => state.duplicatedFields,
  canEdit: (state) => state.canEdit,
  hasEmailDuplicate: (state) => state.duplicatedFields.includes('email'),
  hasPhoneDuplicate: (state) => state.duplicatedFields.includes('phone')
}

const mutations = {
  SET_HAS_DUPLICATES(state, value) {
    state.hasDuplicates = value
  },

  SET_DUPLICATED_FIELDS(state, fields) {
    state.duplicatedFields = fields || []
    state.hasDuplicates = fields && fields.length > 0
  },

  ADD_DUPLICATED_FIELD(state, field) {
    if (!state.duplicatedFields.includes(field)) {
      state.duplicatedFields.push(field)
      state.hasDuplicates = true
    }
  },

  REMOVE_DUPLICATED_FIELD(state, field) {
    const index = state.duplicatedFields.indexOf(field)
    if (index > -1) {
      state.duplicatedFields.splice(index, 1)
      state.hasDuplicates = state.duplicatedFields.length > 0
    }
  },

  CLEAR_DUPLICATES(state) {
    state.hasDuplicates = false
    state.duplicatedFields = []
  },

  SET_CAN_EDIT(state, value) {
    state.canEdit = value
  }
}

const actions = {
  setDuplicates({ commit }, { hasDuplicates, duplicatedFields }) {
    commit('SET_HAS_DUPLICATES', hasDuplicates)
    commit('SET_DUPLICATED_FIELDS', duplicatedFields)
  },

  addDuplicatedField({ commit }, field) {
    commit('ADD_DUPLICATED_FIELD', field)
  },

  removeDuplicatedField({ commit }, field) {
    commit('REMOVE_DUPLICATED_FIELD', field)
  },

  clearDuplicates({ commit }) {
    commit('CLEAR_DUPLICATES')
  },

  setCanEdit({ commit }, canEdit) {
    commit('SET_CAN_EDIT', canEdit)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
